import { all, call, put, takeLatest } from 'redux-saga/effects'

import apiEndPoints from '@/consts/apiEndPoints'
import api from '@/services/api'
import handleErrors from '@/services/handleErrors'

import { getDriversReply, getDriversRequest } from './reducer'

function* getDrivers() {
  try {
    const response = yield call(api.get, apiEndPoints.drivers.root)

    const drivers = response.data

    yield put(getDriversReply({ drivers }))
  } catch (error) {
    handleErrors(error, 'Não foi possível buscar os motoristas')
    yield put(getDriversReply())
  }
}

export default all([takeLatest(getDriversRequest.type, getDrivers)])
